export default {
  common: {
    confirm: "确定",
    cancel: "取消",
    close: "关闭",
    downloadFailed: "下载失败",
    requestFailed: "请求失败",
    processing: "处理中",
    logout: "退出登录",
    login: "登录",
    signup: "注册账号",
    language: "语言",
    expand: "展开",
    collapse: "收起",
    buyNow: "选择方案",
    improve: "优化",
    upgrade: "升级套餐",
    search: "搜索",
    newProject: "新建项目",
    view: "查看",
    open: "打开",
    noMore: "没有更多数据了",
    performTasks: "正在进行的任务：",
    account: "账户",
    demo: "演示",
    contact: "联系我们",
    userManage: "用户管理",
    // 测试面板相关
    test: {
      title: "测试",
      expand: "展开",
      collapse: "收起",
      loginStatus: "登录状态",
      subscriptionStatus: "订阅状态",
      currentUser: "当前用户",
      currentRole: "当前角色",
      isAdmin: "管理员",
      adminPrivileges: "管理员权限",
      userType: "用户类型",
      shortcuts: "快捷操作",
      loggedIn: "已登录",
      notLoggedIn: "未登录",
      subscribed: "已订阅",
      notSubscribed: "未订阅",
      yes: "是",
      no: "否",
      enabled: "已启用",
      disabled: "已禁用",
      visitor: "访客",
      trial: "试用用户",
      paid: "付费用户",
      orgAdmin: "组织管理员",
      toggleSub: "切换订阅状态",
      toggleAdmin: "切换管理员权限",
      refresh: "刷新页面",
    },
    // API 错误码多语言提示
    errorCodes: {
      server_error: "服务器错误",
      param_empty: "参数不能为空",
      unauthorized: "未授权错误",
      user_not_registered: "用户未注册",
      user_exists: "用户已存在",
      user_disabled: "用户已被禁用",
      forbidden: "禁止操作",
      user_quota_insufficient: "用户名额不足",
      data_not_found: "数据不存在",
      data_exists: "数据已存在",
      name_exists: "名称已存在",
      project_id_empty: "项目ID不能为空",
      project_not_found: "项目不存在",
      task_type_empty: "任务类型不能为空",
      project_file_name_empty: "项目文件名不能为空",
      insufficient_space: "空间不足",
      task_id_empty: "任务ID不能为空",
      task_not_found: "任务不存在",
      task_name_empty: "任务名称不能为空",
      task_template_not_found: "任务模板不存在",
      task_processing: "任务正在处理",
      status_empty: "状态不能为空",
      size_empty: "大小不能为空",
      algorithm_id_empty: "算法ID不能为空",
      input_param_empty: "输入参数不能为空",
      project_data_empty: "项目数据不能为空",
      file_upload_failed: "文件上传失败",
      file_size_empty: "文件大小不能为空",
      user_has_org: "用户已有归属组织",
      billing_cycle_not_found: "计费周期不存在",
      parent_node_id_empty: "父节点id不能为空",
      share_not_found: "分享的内容不存在",
      share_expired: "分享的内容已过期",
      share_requires_password: "分享的内容需要密码",
      share_password_incorrect: "分享密码错误",
      user_not_found: "用户不存在",
      username_exists: "用户名已存在",
      login_failed: "登录失败",
      email_exists: "邮箱已存在",
      reg_email_sent: "注册邮件已发送",
      password_incorrect: "密码错误",
    },
  },
  layout: {
    title: "云计算门户",
  },
  pages: {
    dashboard: "控制台",
    projects: "项目管理",
    pipelines: "流程管理",
    tasks: "任务管理",
  },
  home: {
    hero: {
      titleAccent: "SLAM 云计算 + AEC",
      titleMain: "解决方案",
      subtitle:
        "我们为您提供手持式 LiGrip，覆盖从数据采集、处理到 3D 可视化的完整 AEC 工作流。",
    },
    workflow: {
      kicker: "一体化工作流",
      title: "一体化 AEC 数据协作平台",
      description:
        "从现场到云端，从协同到决策，让数据流转更智能，让团队协作更高效。",
      videoAlt: "一体化工作流演示视频",
      playAlt: "播放视频",
      pauseAlt: "暂停视频",
      cards: {
        integration: {
          title: "一体化工作流",
          description:
            "移动 App + 云计算 + AEC 数据分析 + 分享无缝集成。从现场数据采集、云端计算处理，到专业分析与协同共享，打通端到端的数据链路，建立完整的决策闭环。",
        },
        minimalist: {
          title: "极简操作",
          description:
            "一键上传，自动计算，无需复杂培训。通过 LiShare 上传原始数据后，后台自动完成处理，让团队聚焦核心业务，而非软件操作本身。",
        },
        collaboration: {
          title: "团队协作",
          description:
            "支持多用户实时在线协作与批注。可在模型和图纸上同时评论、分派任务并同步反馈，显著提升跨专业、跨区域的协同效率。",
        },
        analysis: {
          title: "数据分析与报告输出",
          description:
            "内置强大的标注与测量工具，适配多种 AEC 场景，可一键生成标准化数据报告（PDF、Excel 等），为项目汇报和决策分析提供有力支撑。",
        },
        deployment: {
          title: "私有化部署",
          description:
            "支持部署在企业自有服务器，数据完全自主可控。满足高等级安全与行业合规要求，确保核心资产与项目数据不外泄。",
        },
        security: {
          title: "数据安全与隐私",
          description:
            "LiShare 已获得 ISO 27001 + ISO 27701 双重认证。从技术、流程到管理全面保障数据与隐私安全，为您的业务提供完整防护。",
        },
      },
    },
    pricing: {
      title: "价格",
      currency: "CHF",
      period: "/月",
      billing: {
        monthly: "按月计费，",
        yearly: "按年计费，",
        threeYears: "按 3 年计费，",
      },
      taxText: "不含税",
      popular: "最受欢迎",
      tabs: {
        monthly: "月付",
        yearly: "年付",
        yearlyBadge: "省 17%",
        threeYears: "3 年",
        threeYearsBadge: "省 44%",
      },
      cta: {
        select: "选择方案",
        contact: "联系销售",
      },
      plans: {
        starter: {
          name: "Starter",
          summary: "轻松分享、存储与处理，适合个人用户。",
          features: ["每年含 500 个免费积分", "免费自助培训"],
        },
        pro: {
          name: "Pro",
          summary: "项目跟踪、进阶处理选项与便捷分享，适合专业中小团队。",
          features: ["每年含 2,500 个免费积分", "免费自助培训"],
        },
        team: {
          name: "Team",
          summary: "为协作型团队提供共享工作空间、权限管理与更高处理额度。",
          features: ["每年含 1,200 个免费积分", "共享团队工作区"],
        },
        business: {
          name: "Business",
          summary:
            "适合多项目并行推进的业务团队，拥有更高配额与更灵活的协同能力。",
          features: ["每年含 5,000 个免费积分", "优先处理与多项目管理"],
        },
        enterprise: {
          name: "Enterprise",
          summary:
            "更强的团队访问能力，并可与第三方系统无缝集成，适合需要高扩展性的企业级团队。",
          customLabel: "定制价格",
          customPrice: "欢迎联系",
        },
      },
    },
    footer: {
      brand: "Cloud-SLAM",
      description:
        "作为一体化 SLAM + 云计算解决方案提供商，我们致力于将先进的空间感知技术与云计算能力结合，为客户提供高效便捷的 3D 数字化工具。",
      contactTitle: "联系我们：",
      address: "729 Heinz Avenue, Suite 9, Berkeley, California 94710, USA",
      phone: "400-009-9312",
      email: "contact@cloud-slam.com",
      time: "周一至周五，9:00–18:00",
    },
  },
  paymentSuccess: {
    iconAlt: "支付成功",
    title: "您的订单已支付成功",
    orderNumber: "订单号：",
    orderTime: "下单时间：",
    orderAmount: "订单金额：",
    billingCycle: "计费周期：",
    amountPrefix: "USD $",
    action: "查看订单并生成发票",
    placeholder: "XXXXXXXXXXXXXXXXX",
    intervalUnit: {
      DAY: "按日",
      MONTH: "按月",
      YEAR: "按年",
    },
  },
  paymentFailed: {
    iconAlt: "支付失败",
    title: "您的支付已中断",
    orderNumber: "订单号：",
    orderTime: "下单时间：",
    backToStore: "返回首页",
    continueToPay: "继续使用 PayPal 支付",
    amountPrefix: "USD $",
    amountPlaceholder: "USD $",
    placeholder: "XXXXXXXXXXXXXXXXX",
  },
  projectManage: {
    deleteTitle: "确认删除",
    deletePrompt: "确定要删除项目「{name}」及其所有数据吗？",
    renameTitle: "重命名项目",
    projectNameLabel: "项目名称",
    projectNamePlaceholder: "请输入项目名称",
    newTitle: "新建项目",
    newPlaceholder: "请输入项目名称",
    loading: "加载中…",
    noData: "暂无数据",
    noMoreData: "没有更多数据了",
    // Messages
    loadListFailed: "加载项目列表失败",
    pleaseEnterName: "请输入项目名称",
    nameLengthInvalid: "项目名称应为 2–20 个字符",
    createSuccess: "项目创建成功",
    deleteSuccess: "项目删除成功",
    renameSuccess: "项目重命名成功",
  },
  engineeringManage: {
    pageTitle: "项目管理",
    backHome: "返回上一页",
    uploadData: "上传数据",
    projectIdLabel: "项目 ID",
    defaultProjectTitle: "软件新城测绘项目",
    tableName: "名称",
    tableCreationTime: "创建时间",
    tableAlgorithm: "类型",
    tableSize: "大小",
    tableState: "状态",
    tableOperation: "操作",
    statusFilterPlaceholder: "按状态筛选",
    statusAll: "全部状态",
    statusOptions: {
      failed: "失败",
      running: "运行中",
      success: "已完成",
      init: "初始化中",
      uploading: "上传中",
      upload_success: "上传完成",
      wait_process: "排队中",
      upload_fail: "上传失败",
    },
    noData: "暂无数据",
    previous: "上一页",
    next: "下一页",
    operationPending: "暂不可用",
    uploadPending: "上传功能暂不可用",
    actionLog: "日志",
    actionFeedback: "反馈",
    actionExport: "报告预览",
    actionContact: "联系我们",
    actionDownload: "下载",
    actionDelete: "删除",
    stateInit: "初始化中",
    stateUploading: "上传中",
    stateFailed: "失败",
    stateUploadSuccess: "上传完成",
    stateWaitProcess: "排队中",
    stateUploadFail: "上传失败",
    stateRunning: "运行中",
    stateSuccess: "已完成",
    deleteTitle: "确认删除",
    deletePrompt: "确定要删除任务「{name}」吗？",
    deleteConfirm: "确定要删除任务「{name}」吗？",
    deleteSuccess: "任务删除成功",
    deleteFailed: "任务删除失败",
    feedbackSuccess: "反馈提交成功",
    downloadSuccess: "下载已开始",
    noExportTypes: "暂无可导出的类型",
    loadExportTypesFailed: "获取导出类型失败",
    downloadFailed: "下载失败",
    exportDataTitle: "导出数据",
    exportDataCancel: "取消",
    exportDataConfirm: "确认",
    exportDataOriginal: "原始数据",
    fileFormatLiData: "点云数据",
    fileFormatGeojson: "轨迹数据",
    fileFormatPdf: "报告",
  },
  taskPanel: {
    projectName: "古木调查项目",
    projectDate: "2026 年 2 月 10 日",
    eta: "预计还需 {time}",
    processing: "处理中",
    waiting: "等待中",
    error: "异常",
    statusFailed: "失败",
    statusRunning: "运行中",
    statusSuccess: "已完成",
    statusInit: "初始化中",
    statusUploading: "上传中",
    statusUploadSuccess: "上传完成",
    statusWaitProcess: "排队中",
    statusUploadFail: "上传失败",
    moveUp: "上移",
    moveDown: "下移",
    view: "查看",
    delete: "删除",
    taskIconAlt: "任务",
  },
  message: {
    EnablePanoPoints: "启用全景点",
    title: "标题",
    map: "地图",
    indexPage: "首页",
    log: "日志",
    data: "数据",
    list: "列表",
    add: "添加",
    edit: "编辑",
    rename: "重命名",
    share: "分享",
    download: "下载",
    detail: "详情",
    projectRename: "项目重命名",
    startPoint: "起始点",
    targetPoint: "目标点",
    update: "修改",
    delete: "删除",
    ok: "确定",
    operation: "系统正在升级维护中，请稍候",
    close: "关闭",
    allData: "全部数据",
    open: "打开",
    open2: "开",
    close2: "关",
    name: "名称",
    dateSettings: "日期设置",
    passwordProtection: "密码保护",
    fieldName: "字段名",
    fieldValue: "字段值",
    userStatus: "用户状态无效",
    collisionOpen: "碰撞检测已开启",
    collisionClose: "碰撞检测已关闭",
    maintenance: "系统维护中",
    version1: "为提升系统性能与稳定性，",
    version2: "系统正在进行计划性维护升级",
    maintenanceTime: "维护时间",
    kindReminder: "温馨提示",
    expectedImpact: "预计影响",
    maintenanceContent: "维护内容",
    tis1: "1. 请提前安排好相关工作，避开此时段进行操作。",
    tis2: "2. 维护结束后，系统将自动恢复正常服务。如遇特殊情况导致维护时间延长，我们将另行通知。",
    tis3: "3. 维护完成后，如有任何异常情况，请及时联系技术支持。",
    tis4: "4. 感谢您的理解与支持！我们将努力缩短维护时间，减少对您的影响。",
    startTime: "开始时间",
    endTime: "预计恢复时间",
    joystickPrompt: "摇杆控制",
    joystickPrompt2: "返回起始点",
    joystickPrompt3: "打开设置",
    joystickPrompt4: "开启/关闭碰撞检测",
    next: "下一步",
    type: "类型",
    date: "日期",
    action: "操作",
    view: "查看",
    share: "项目分享",
    shareSettings: "分享设置",
    noData: "暂无全景数据",
    sceneNoDataTitle: "提示",
    sceneNoPointCloudData: "当前场景暂无点云数据",
    upload: "上传",
    window: "窗口",
    windowSelection: "窗口选择",
    measure: "测量",
    annotation: "标绘",
    vectorLayer: "矢量图层",
    panoramicLayer: "全景图层",
    pointCloudLayer: "点云图层",
    model: "模型",
    obliquePhotography: "3D Tiles",
    cityJson: "CityJSON",
    pcColor: "背景颜色",
    manage: "管理",
    panorama: "全景",
    home: "主屏",
    photo: "照片",
    setting: "设置",
    visualAngle: "视角",
    pointCloud: "点云",
    gaussLayer: "3DGS",
    label: "标注",
    clear: "清除",
    layer: "图层",
    cropping: "裁剪",
    cropEffect: "裁剪效果",
    bOXRange: "包围盒范围",
    XAxis: "X 轴旋转",
    YAxis: "Y 轴旋转",
    ZAxis: "Z 轴旋转",
    croppingMaxLimit: "最多可创建 8 个裁剪框",
    selectBox: "请至少选择一个框",
    not: "无",
    High: "高",
    internal: "内部",
    external: "外部",
    tianditu: "天地图",
    point: "点",
    line: "线",
    polygon: "面",
    prompt: "请到设置中查看图层数据。",
    cutting: "请选择裁切点",
    svcutting: "正在保存裁剪结果…",
    save: "保存",
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    BOXRange: "包围盒范围",
    long: "长",
    wide: "宽",
    tall: "高",
    AxisX: "X 轴旋转",
    AxisY: "Y 轴旋转",
    AxisZ: "Z 轴旋转",
    cuttingResult: "裁剪结果",
    cuttingOperation: "请选择裁切点或点击裁剪结果后操作",
    area: "面积",
    share2: "分享状态不可操作",
    angle: "角度",
    draw: "绘制",
    desc: "备注",
    color: "颜色",
    size: "大小",
    device: "设备",
    tree: "树",
    custom: "自定义",
    startPoint: "起点",
    kilometer: "公里",
    default: "默认",
    display: "显示",
    scanQRCode: "扫描二维码",
    scanBrowser: "可用浏览器扫码查看",
    createShareUrlSuccess: "分享链接创建成功",
    previewProject: "预览项目",
    clip: "裁剪",
    highLight: "高亮",
    inner: "内部",
    outer: "外部",
    jump: "跳转",
    frames: "帧",
    current: "当前",
    total: "共",
    lastFrames: "上一帧",
    nextFrames: "下一帧",
    yes: "是",
    no: "否",
    deleteConfirm: "确认删除",
    deleteCannotUndo: "删除后不可恢复",
    Time: "时间",
    isDeleteData: "是否删除选中的数据",
    checkAll: "全选",
    pointSize: "点大小",
    minSize: "最小大小",
    nameCannotRepeat: "名称不可重复",
    plzInputDesc: "请输入备注",
    attr: "属性",
    plzInputLayerName: "请输入图层名称",
    tool: "工具",
    detailMessage: "详细信息",
    search: "搜索",
    ground: "地面",
    airborne: "机载",
    annotation: "标注",
    effectiveTime: "有效时间",
    password: "密码",
    day: "天",
    reset: "重置",
    document: "文档",
    index: "首页",
    inputTis: "请输入项目名称",
    successCreateShareUrl: "分享链接创建成功",
    createShareUrlFail: "分享链接创建失败",
    effective: "有效",
    copyUrl: "复制链接",
    scanQrCode: "扫描二维码",
    scanTheQrCodeWithABrowserToView: "可用浏览器扫码查看",
    plzEnterAnInteger: "请输入整数",
    shareDayCannotLessThanOne: "分享天数不得少于 1 天",
    shareDayTis: "分享天数最多不超过 14 天",
    copyShareUrlSuccess: "分享链接已复制",
    browerNotSupportAutoCopy: "当前浏览器不支持自动复制",
    pickUpPanorama: "拾取全景点",
    panoramicSettings: "全景设置",
    trajectorySettings: "轨迹设置",
    playOptions: "播放选项",
    measureTool: "测量工具",
    clipTool: "裁剪工具",
    navigatation: "导航",
    uploadSuccess: "上传成功",
    uploadFailed: "上传失败",
    unupload: "未上传",
    uploadingtis: "正在上传",
    unviewAttr: "不可见属性",
    addLayer: "添加图层",
    panoramapoint: "全景点",
    editLayer: "编辑图层",
    pointLayer: "点图层",
    lineLayer: "线图层",
    polygonLayer: "面图层",
    mapLabel: "地图标注",
    customLabel: "自定义标注",
    pickGpkg: "选择 GPKG",
    pcSetting: "点云设置",
    shape: "形状",
    pointType: "点模式：",
    attribute: "属性",
    classification: "点云分类",
    background: "背景",
    skybox: "天空盒",
    gradient: "渐变色",
    black: "黑色",
    white: "白色",
    opacity: "透明度",
    strength: "强度",
    EDLradius: "半径",
    enable: "EDL",
    control: "控制器",
    currentViewControlModel: "当前视角控制模式",
    toolTipContent1: "右键结束单次选点，点击选点按钮结束选点",
    toolTipContent2: "右键结束单次测量，点击测量按钮结束测量",
    birthPointSetting: "初始位置设置",
    earth_controls: "地球控制模式",
    orbit_controls: "轨道控制模式",
    view_left: "左",
    view_right: "右",
    view_top: "上",
    view_bottom: "下",
    view_front: "前",
    view_back: "后",
    view_focus: "聚焦",
    cannotBeEmpty: "不能为空",

    UserOperationManual: "用户操作手册",
    userCenter: "用户中心",

    Range: "范围",
    Gamma: "Gamma",
    Brightness: "亮度",
    Contrast: "对比度",

    magnify: "放大",
    lessen: "缩小",

    about: "关于",
    contact: "联系我们",
    privacy: "隐私政策",
    terms: "服务条款",

    RGB: "RGB",
    intensity: "强度",
    classification: "分类",
    elevation: "高程",
    treeid: "树 ID",
    return_number: "回波",
    number_of_returns: "回波次数",
    colorMap: "色带：",
    shareCodeCannotLessThanSix: "分享码长度不得少于 6 位",
    sharePasswordInvalid: "分享密码仅支持数字和大小写英文字母，长度为 4–6 位",
    deleteOK: "删除成功",
    enterPassword: "请输入密码",
    pageNotExist: "抱歉，您访问的页面不存在",
    goBack: "返回",
    enterLimitTime: "请输入有效时间",
    //new
    roam: "漫游",
    property: "属性",
    plotting: "标绘",
    croppingWarning: "此功能目前仅支持点云数据。",
    user: "个人中心",
    fenxiang: "分享",
    setting: "设置",
    setting2: "设置",
    collision: "碰撞检测",
    fixed: "固定大小",
    adaptive: "自适应大小",
    attenuated: "衰减",
    Square: "方形",
    Circle: "圆形",
    Paraboloid: "抛物面",
    Link: "链接",
    CopyUrl: "复制链接",
    attributeMap: {
      0: "颜色",
      1: "文件",
      3: "高程",
      4: "强度",
      8: "分类",
      9: "回波",
      15: "回波次数",
      14: "树 ID",
    },
    Current: "当前帧",
    Step: "步长",
    JumpSpeed: "跳转速度",
    LoopPlayback: "循环播放",
    FixedPerspective: "固定视角",
    attributeNames: [
      "创建点，未分类",
      "未分类点",
      "地面点",
      "低矮植被点",
      "中等植被点",
      "高植被点",
      "建筑物点",
      "低点",
      "模型关键点",
      "水体点",
      "车辆点",
      "路灯点",
      "重叠点",
      "屋顶点",
      "墙壁点",
      "杆状物点",
      "电力线",
      "杆塔点",
      "上交跨点",
      "下交跨点",
      "地线点",
      "静止车辆点",
      "移动车辆点",
      "树干点",
      "枝叶点",
      "广告牌",
      "护栏点",
      "绝缘子点",
      "引流线点",
      "桥梁点",
      "巷道壁",
      "通风管道",
      "线缆",
      "吊灯",
      "电箱",
      "附着物",
      "杂物",
      "噪点",
      "道路点",
      "默认",
      "未分类点",
    ],
    loginLiShare: "登录",
    loginAccount: "账号",
    loginAccountPlaceholder: "请输入账号",
    loginPassword: "密码",
    loginPasswordPlaceholder: "请输入密码",
    loginRememberMe: "记住密码",
    loginForgotPassword: "忘记密码？",
    loginNewUser: "新用户？",
    loginButton: "登录",
    rememberMe: "记住我",
    loginPhone: "手机号登录",
    phone: "手机号",
    loginPhonePlaceholder: "请输入手机号",
    loginPhoneFormatPlaceholder: "请输入正确的手机号格式",
    loginCodePlaceholder: "请输入验证码",
    loginSuccess: "登录成功",
    loginFailed: "登录失败，请检查手机号和验证码",
    loginRegisterSameAgreeTerms: "请同意用户协议和隐私政策",
    loginCode: "验证码",
    loginSendCode: "发送",
    loginSendCodeSuccess: "发送成功",
    loginSendCodeFailed: "验证码发送失败",
    loginBeian: "京ICP备13007633号-2",
    loginBeianNumber: "京公网安备 11010802026375号",
    loginEmail: "邮箱",
    loginEmailPlaceholder: "请输入邮箱地址",
    loginSubmit: "提交",
    loginUsername: "用户名",
    loginRegister: "注册账号",
    loginCompany: "公司",
    loginCompanyPlaceholder: "请输入公司名称",
    loginPassword: "密码",
    loginRegisterPassword: "请输入注册密码",
    loginConfirmPassword: "确认密码",
    loginConfirmPasswordPlaceholder: "请确认密码",
    loginRegisterPasswordPlaceholder: "请输入注册密码",
    loginRegisterConfirmPassword: "确认密码",
    loginRegisterConfirmPasswordPlaceholder: "请确认注册密码",
    loginRegisterIndustry: "行业",
    loginRegisterIndustryPlaceholder: "请选择所属行业",
    loginRegisterIndustryFailed: "获取行业列表失败，请稍后重试",
    loginRegisterPhone: "手机号码",
    loginRegisterPhonePlaceholder: "请输入手机号码",
    loginRegisterSamePhoneFormat: "请输入正确的手机号码",
    loginRegisterButton: "注册",
    loginRegisterSamePassword: "两次密码输入一致",
    loginRegisterSamePasswordFailed: "两次密码输入不一致",
    loginRegisterSameAccount: "账号已存在",
    loginRegisterSameAccountFailed: "账号不存在",
    loginRegisterSamePhone: "手机号已存在",
    loginRegisterSamePhoneFailed: "手机号不存在",
    loginRegisterSameEmail: "邮箱已存在",
    loginRegisterSameEmailFailed: "邮箱不存在",
    loginRegisterSameCode: "验证码错误",
    loginRegisterSameCodeFailed: "验证码正确",
    loginRegisterSameAccountLength: "账号长度应为 3–20 个字符",
    loginUsernameFormat: "用户名应为 3–20 位字母、数字或下划线，或有效的邮箱地址",
    loginCompanyNameLength: "公司名称应为 2–20 个字符",
    loginRegisterSamePasswordLength: "密码长度应为 6–20 个字符",
    loginPasswordComplexity: "密码应为 6–20 位，且包含字母、数字、符号中至少两种",
    loginRegisterSamePasswordConfirm: "两次输入的密码不一致",
    loginEmailFormatPlaceholder: "请输入正确的邮箱格式",
    loginSendCodeSuccess: "验证码已发送，请注意查收",
    loginSendCodeFailed: "验证码发送失败，请稍后重试",
    loginVerifyCodeFailed: "验证失败，请检查验证码",
    loginRegisterSamePhoneLength: "手机号长度应为 11 位",
    loginRegisterAgreeTerms: "我已阅读并同意",
    loginRegisterTerms: "使用条款",
    loginRegisterGVITerms: "GVI 服务协议",
    forgotPassword: "忘记密码",
    loginRegisterSameAccountTip: "已有账号？",
    loginRegisterFailed: "注册失败，请稍后重试",
    loginNewPassword: "新密码",
    loginNewPasswordPlaceholder: "请输入新密码",
    loginConfirmNewPassword: "确认新密码",
    loginConfirmNewPasswordPlaceholder: "请再次输入新密码",
    loginResetSuccess: "密码重置成功，请登录",
    loginResetFailed: "密码重置失败，请稍后重试",

    // 注册相关
    signup: {
      createAnAccount: "创建账户",
      fullName: "用户名",
      enterFullName: "请输入用户名",
      emailAddress: "邮箱地址",
      enterEmailAddress: "请输入邮箱地址",
      company: "公司",
      pLcompany: "请输入公司名称",
      password: "密码",
      confirmPassword: "确认密码",
      industry: "行业",
      industryInput: "请至少选择一个选项",
      readAgree: "我已阅读并同意",
      terms: "使用条款",
      GVI: "GVI 服务协议",
      remember: "请勾选条款信息",
      createAccount: "创建账户",
      haveAccount: "已有账户？",
      successfullySentEmail: "注册邮件已发送，请查收",
      failedToSendEmail: "注册邮件发送失败",
      status: {
        industryInput: "请至少选择一个选项",
        zcsucceeded: "注册成功",
      },
      emailAlreadyInUse: "该邮箱地址已被注册",
      fullNameAlreadyInUse: "该用户名已被注册",
      goToDashboard: "前往控制台",
      new_password: {
        login: "登录",
      },
    },

    // 忘记密码
    forgotPassword: "忘记密码",
    forgotPasswordTitle: "重置密码",
    phoneNumber: "手机号",
    pleaseEnterPhoneNumber: "请输入手机号",
    verificationCode: "验证码",
    pleaseEnterVerificationCode: "请输入验证码",
    sendCode: "发送验证码",
    resendCode: "重新发送",
    sendCodeSuccess: "验证码已发送",
    newPassword: "新密码",
    pleaseEnterNewPassword: "请输入新密码",
    confirmNewPassword: "确认新密码",
    pleaseConfirmNewPassword: "请确认新密码",
    passwordNotMatch: "两次输入的密码不一致",
    email: "邮箱",
    pleaseEnterEmail: "请输入邮箱地址",
    resetSuccess: "密码重置成功",
    resetFailed: "密码重置失败",
    emailSentSuccess: "邮件已发送，请查收",
    backToLogin: "返回登录",
    submit: "提交",
    codeSentToEmail: "重置链接已发送到您的邮箱",
    clickLinkInEmail: "请点击邮件中的链接重置密码",

    All: "全部",
    Share: "共享",
    loading: "加载中…",
    noData: "没有更多数据了",
    spaceExpand: "扩容存储",
    logout: "退出登录",
    spaceExpands: "扩展存储",
    spaceExpandCapacity: "容量（GB）",
    spaceExpandCapacityPlaceholder: "请输入扩展容量（GB）",
    spaceExpandTime: "时长（月）",
    spaceExpandTimePlaceholder: "请输入扩展时长（月）",
    spaceExpandPoints: "消耗积分",
    spaceExpandError: "请输入正确的扩展参数",
    spaceExpandSuccess: "存储扩展成功",

    personalCenter: "个人中心",
    username: "用户名",
    modify: "修改",
    bind: "绑定",
    nickname: "昵称",
    nationality: "国籍",
    industry: "行业",
    modifyInfo: "修改资料",
    securityLevel: "当前账号安全等级",
    securityLevelWeak: "低",
    securityLevelMedium: "中",
    securityLevelHigh: "高",
    loginAccountPassword: "登录密码",
    loginAccountPasswordTip: "登录密码用于保障账户安全",
    bindEmail: "绑定邮箱",
    bindEmailSuccess: "已绑定",
    bindEmailFailed: "未绑定",
    bindEmailTip: "可用于登录、找回密码及安全验证",
    bindPhone: "绑定手机",
    bindPhoneSuccess: "已绑定",
    bindPhoneFailed: "未绑定",
    modifyEmail: "修改邮箱",
    modifyPhone: "修改手机",
    modifyPassword: "修改密码",
    modifySuccess: "修改成功",

    modifyAvatar: "修改头像",
    avatar: "头像",

    unupload: "排队等待中",
    uploading: "数据正在处理中，请稍候",

    shareLinkGenerated: "分享链接已生成",
    shareLinkTip: "您可以将此链接分享给其他人",
    linkExpireTime: "链接有效期",

    recharge: "充值",
    rechargeCardNumber: "请输入充值卡号",
    rechargeCardUsed: "充值卡已使用",

    privacy_info1: "数字绿土隐私政策",
    privacy_info2: "一般信息",
    privacy_info3:
      "在数字绿土，我们认为您有权了解我们在您使用我们的网站及相关应用程序和资源（统称为“服务”）时收集的信息类型，以及这些信息可能被如何使用。本隐私政策旨在说明数字绿土在收集、使用和披露与服务相关的您的信息方面的政策和程序。本隐私政策范围有限，仅适用于本服务。",
    privacy_info4:
      "访问本服务即表示您同意按照本隐私政策（以下简称“隐私政策”）的规定收集、使用和披露您的个人信息。本隐私政策已纳入服务条款并受其约束，服务条款可在此处访问。您对本服务的使用以及通过本服务提供的任何信息均受本隐私政策和我们的服务条款约束。",
    privacy_info5: "您将在本隐私政策中了解什么？",
    privacy_info6: "我们如何收集您的信息",
    privacy_info7: "我们如何使用或共享您的信息",
    privacy_info8: "我们如何保护您的信息",
    privacy_info9: "与我们收集的您的信息相关的其他事项",
    privacy_info10: "信息收集",
    privacy_info11: "我们通过多种方式收集与服务相关的您的信息。",
    privacy_info12:
      "注册。要使用本服务提供的某些功能和资源，用户必须完成我们的注册流程。注册过程中，用户需要提供特定类别的信息，其中可能包括个人身份信息以及关于您的其他信息，例如您的姓名、地址、电子邮箱、社交网络账户信息、密码、用户类型、出生日期、性别、电话号码，以及您如何得知数字绿土。",
    privacy_info13:
      "可选信息。在您使用本服务的其他环节，您可以选择提供与您相关的其他信息。例如，您可能希望创建个人资料、发布内容、评论其他用户的帖子或与他人分享帖子，或者您可能希望使用社交网络集成功能或基于位置的服务功能。对于这些自愿活动，您可以选择是否披露使用这些服务功能所需的信息。",
    privacy_info14:
      "被动信息收集。除了您通过完成注册流程、评论或分享帖子等方式主动向我们提供的信息外，我们还收集您与本服务交互的相关信息。我们收集被动信息的目的包括测试和改善用户使用本服务的体验，以及为内部目的和向第三方（如广告商和业务合作伙伴）披露而编制人口统计数据和相关使用信息。我们收集的被动信息类型包括但不限于您的浏览器发送的某些标准信息，例如您的互联网协议（IP）地址、设备 ID、浏览器类型和功能、语言、操作系统、访问本服务的日期和时间，以及您链接到本服务的来源网站。我们还收集与您在本服务中的行为相关的信息（例如查看的页面、点击的链接以及在本服务中执行的其他操作）。我们还可能利用网站中嵌入的特殊链接、电子图像或其他对象（有时称为网络信标或跟踪像素）来收集信息，以帮助确定和分析您和其他访问者如何使用网站。如果您通过注册或其他自愿方式向我们提供了个人信息，我们可能会将您的个人信息与通过我们的网站收集的被动信息关联起来，并使用组合信息帮助确定您对某些产品、服务或信息的潜在兴趣，以及用于本隐私政策中描述的其他目的。",
    privacy_info15:
      "Cookie。与您与本服务交互相关的信息可能由我们收集并存储在小型数据文件中，这些文件通常称为 Cookie，由我们的服务器放置在您的设备上。我们可能会使用临时会话 Cookie（在您关闭当前会话时终止）来存储您提供的某些个人信息，用于管理该会话并促进您在该会话期间请求的交易。我们还可能使用持久性 Cookie（在当前会话关闭后仍保留在您的设备上）来存储与您与本服务交互相关的信息，以便促进未来的会话。大多数浏览器会自动接受 Cookie，但您通常可以修改浏览器设置以拒绝 Cookie 或在设备上放置 Cookie 时通知您。每个浏览器都不同，但通常用户可以按照浏览器“帮助”文件中提供的说明删除 Cookie。请注意，如果您拒绝或禁用 Cookie，本服务的某些功能可能无法正常运行。",
    privacy_info16:
      "未成年人信息收集。本服务面向普通受众，不面向 13 岁以下儿童。禁止 13 岁以下任何人使用本服务。如果您年龄在 13 至 18 岁之间，必须在使用本服务之前获得父母或法定监护人的授权。尽管本服务可能包含儿童感兴趣的信息，但本服务并非面向儿童，我们也不会故意收集或索取 13 岁以下儿童的个人信息。",
    privacy_info17: "信息的使用和共享",
    privacy_info18:
      "本服务使用户能够在数字绿土社区、其他社交网络和其他网站及在线服务中发布、访问和共享用户生成的内容和其他信息，并可能包括各种功能和特性，例如评论、留言板或聊天区，用户可以在其中发布信息并相互交流。请注意，这些帖子和通信是在网上公开进行的，您需自行承担相关风险。",
    privacy_info19:
      "除根据本隐私政策规定的条款外，我们不会故意使用、共享或以其他方式传输您的信息。此外，我们可能会出于已获得您同意的其他目的使用、共享或以其他方式传输您的信息。您的同意可以是默示的、视为的（使用选择退出机制）或明示的。明示同意可以口头、电子或书面形式给予。默示同意是可以从您的行为或不行为中合理推断出的同意。无论您是否决定共享您的个人信息，我们可能会以汇总或匿名方式与我们的业务合作伙伴共享人口统计数据和相关使用信息，以删除或隐藏能够识别任何个人用户的个人信息。",
    privacy_info20:
      "我们可能会使用您的信息来向您提供产品和服务，并根据您的兴趣定制本服务，提升您的整体使用体验。我们尝试使用各种方法识别您，包括让您使用用户名和密码登录。一旦我们识别出您，您的体验可能会为您定制，以便您看到最感兴趣的内容。此外，如上所述，我们利用被动信息来了解更多关于您如何与本服务交互的信息。此被动信息可能与其他信息结合使用，并用于增强您使用本服务的体验、改进本服务、测试和增强安全性，以及为我们的内部目的和本隐私政策中描述的其他目的编制人口统计数据和相关使用信息。",
    privacy_info21:
      "虽然我们努力保护用户的个人信息，但如果适用法律或法规要求，或出于善意认为此类行动是必要或适当的，我们可能会在您不知情或不同意的情况下使用、共享或以其他方式传输您的个人信息。",
    privacy_info22:
      "我们可能会不时决定使用第三方来执行与本服务相关的特定功能，这样效率更高。如果我们使用第三方来执行特定功能（例如代表我们向用户发送通信），则信息（例如联系信息）可能会在该第三方执行该功能所需的范围内与该第三方共享。我们授权这些第三方服务提供商仅为提供我们要求的特定服务而使用个人身份信息。本段涵盖的第三方服务提供商不包括通过本服务内的链接访问的第三方网站、应用程序或服务，这些受以下更具体条款的约束。",
    privacy_info23:
      "如果您选择加入允许第三方与您联系的功能，您的个人信息（例如您的联系信息和访问本服务期间收集的其他信息）可能会与数据聚合商、营销人员和其他组织共享（可能以列表租赁的形式）。",
    privacy_info24:
      "如果我们将部分或全部业务出售、转让或移交给继任者或收购方，我们可能会将您的所有信息（无论您的状态如何）出售、转让或移交给该继任者或收购方。",
    privacy_info25: "安全",
    privacy_info26:
      "我们已制定安全措施，以防止未经授权访问我们控制下的个人身份信息。我们利用在线和离线安全方法，包括防火墙、密码和对存储您信息的位置的受限物理访问，以帮助保护个人身份信息。我们的员工经过培训，遵守我们的安全程序，我们的安全程序会定期审查，并在我们认为必要时进行修订。",
    privacy_info27: "如何访问和更新您的信息",
    privacy_info28:
      "我们的目标是使我们拥有的任何个人信息尽可能准确、及时和完整，以达到我们使用该信息的目的。如果您想查看、核实或更正您的个人信息，请使用以下列出的联系信息与我们联系。我们保留不更改任何个人信息的权利，而是附加相关个人认为合适的任何替代信息。在某种程度上，我们依靠个人更新自己的个人信息。除非个人告知我们这些重要变更，否则我们可能无法知晓。",
    privacy_info29: "电子邮件列表和如何取消订阅",
    privacy_info30:
      "我们可能会定期使用您的联系信息，向您发送有关本服务更新的电子邮件或其他通信，并提醒您或通知您与本服务相关的事件。这些信息的频率将根据各种因素而有所不同。",
    privacy_info31:
      "如果您不再希望收到我们的电子邮件，并希望从我们的电子邮件列表中删除，请",
    privacy_info32: "联系我们",
    privacy_info33:
      "，并在邮件正文中注明“电子邮件取消订阅”。如果您选择从我们的邮件列表中退订，我们将在档案中保留您的联系信息并做标记，以便在第三方随后向我们提供您的详细信息时，我们不会无意中与您联系。",
    privacy_info34: "其他条款",
    privacy_info35:
      "您使用本服务即表示接受隐私政策的条款。我们保留随时更新或修改本隐私政策的权利。我们将在我们的网站上发布本隐私政策的任何修订版本，并鼓励您定期查阅。除非本隐私政策中另有明确规定，否则本隐私政策任何修订版本中包含的变更将自发布该修订版本之日起生效。",
    privacy_info36:
      "本隐私政策不产生或授予任何个人任何权利，也不对数字绿土施加任何超出或附加于该个人所在司法管辖区隐私法规定的任何权利或义务的权利或义务。不同司法管辖区的隐私立法或个人的隐私权可能有所不同。本隐私政策中描述的权利和义务可能不适用于所有个人或所有司法管辖区。如果在特定情况下，本隐私政策与该个人所在司法管辖区的适用隐私法律之间存在任何不一致，则应对本隐私政策进行解释，以使其生效并遵守该隐私法律。",
    privacy_info37:
      "本隐私政策仅适用于我们通过本服务在线收集的信息，不适用于本服务以外的任何网站、应用程序或服务。本服务包含指向我们不拥有或控制的第三方提供的其他网站、应用程序和服务的链接，我们不对这些第三方的隐私政策和做法负责。同样，我们不对您链接到我们服务的任何其他网站、应用程序和服务的隐私政策和做法负责。我们鼓励您在离开我们的服务时注意，并阅读可能提供网站、应用程序或链接到本服务的信息的每个第三方的隐私政策。",
    privacy_info38:
      "本隐私政策可能包括示例，但其应用并不限于此类示例，因此“包括”是指“包括但不限于”。",
    privacy_info39: "您的隐私对我们很重要。如果您对上述任何条款有任何疑问，请",
    privacy_info40: "最后更新日期：2019-01-24",

    "edit-phoneNewPhone": "新手机号",
    "edit-phoneCurrentPhone": "当前手机号",
    "edit-phoneConfirmPhone": "确认手机号",
    "edit-phoneConfirmPhoneDesc": "验证当前手机号",
    "edit-phoneConfirmSuccess": "修改成功",
    "edit-phoneBindNewPhone": "绑定新手机号",
    "edit-phoneEnterConfirmPhone": "两次输入的手机号不一致。",
    "edit-phoneSave": "保存",
    "edit-phoneChangeSuccess": "手机号验证成功。",
    "edit-phoneCodeError": "验证码错误。",
    "edit-emailCurrentEmail": "当前邮箱地址",
    "edit-emailNewEmail": "新邮箱地址",
    "edit-emailConfirmEmail": "验证当前邮箱",
    "edit-emailTitle": "修改邮箱地址",
    "edit-emailConfirmSuccess": "修改成功",
  },
  accountSetting: {
    title: "账户设置",
    nicknameLabel: "用户名",
    avatarLabel: "头像",
    newPasswordLabel: "新密码",
    confirmNewPasswordLabel: "确认新密码",
    emailLabel: "邮箱",
    emailSupportHint: "如需修改邮箱，请联系 GreenValley 支持团队。",
    companyLabel: "公司",
    industryLabel: "行业",
    avatarImageOnly: "请上传图片文件",
    avatarTooLarge: "头像文件大小不能超过 5 MB",
    loadFailed: "获取账户信息失败",
    uploadSuccess: "头像上传成功",
    uploadFailed: "头像上传失败",
    updateSuccess: "账户信息更新成功",
    updateFailed: "账户信息更新失败",
    industryOptions: {
      surveyingMapping: "测绘与地图",
      forestryEcology: "林业与生态",
      smartCity: "智慧城市",
    },
    rules: {
      nicknameRequired: "请输入用户名",
      nicknameInvalid: "用户名应为 3–20 位字母、数字或下划线，或有效的邮箱地址",
      avatarRequired: "请上传头像",
      emailRequired: "请输入邮箱",
      emailInvalid: "请输入正确的邮箱格式",
      newPasswordRequired: "请输入新密码",
      newPasswordInvalid: "密码应为 6–20 位，且包含字母、数字、符号中至少两种",
      confirmNewPasswordRequired: "请输入确认新密码",
      confirmNewPasswordMismatch: "新密码与确认新密码不一致",
    },
  },
  userManage: {
    pageTitle: "用户管理",
    backHome: "返回上一页",
    newUser: "新建用户",
    loading: "加载中…",
    username: "用户名",
    usernameSearchPlaceholder: "请输入用户名搜索",
    email: "邮箱",
    effective: "状态",
    lastLogin: "最后登录时间",
    operation: "操作",
    normal: "正常",
    disabled: "已禁用",
    view: "查看",
    edit: "编辑",
    delete: "删除",
    previous: "上一页",
    next: "下一页",
    noData: "暂无用户数据",
    deleteConfirmTitle: "确定要删除用户「{name}」吗？",
    loadListFailed: "加载用户列表失败",
    createSuccess: "用户创建成功",
    createFailed: "用户创建失败",
    updateSuccess: "用户更新成功",
    updateFailed: "用户更新失败",
    deleteSuccess: "用户删除成功",
    deleteFailed: "用户删除失败",
    modal: {
      createTitle: "创建用户",
      editTitle: "编辑用户",
      viewTitle: "查看用户",
      usernameLabel: "用户名",
      usernamePlaceholder: "请输入用户名",
      emailLabel: "邮箱",
      emailPlaceholder: "请输入邮箱",
      effectiveLabel: "状态",
      emailAction: "邮箱操作",
      rules: {
        usernameRequired: "请输入用户名",
        usernameInvalid: "用户名应为 3–20 位字母、数字或下划线，或有效的邮箱地址",
        emailRequired: "请输入邮箱",
        emailInvalid: "请输入正确的邮箱地址",
        effectiveRequired: "请选择状态",
      },
    },
  },
  threeD: {
    layers: "图层",
    filterByNameAndTags: "按名称和标签筛选…",
    pointCloudLayers: "点云图层",
    panoramicLayers: "全景图层",
    vectorLayers: "矢量图层",
    annotationLayers: "标注图层",
    modelLayers: "模型图层",
    gaussLayers: "3DGS 图层",
    obliquePhotographyLayers: "3D Tiles 图层",
    visibility: "可见性",
    rename: "重命名",
    editStyle: "编辑样式…",
    zoomToLayer: "缩放至图层",
    exportData: "导出数据…",
    delete: "删除",
    attributeTable: "属性表",
    twoDView: "2D 视图",
    threeDView: "3D 视图",
    resetView: "重置视图",
    zoomToFullExtent: "缩放至全图",
    pointAnnotation: "点标注",
    lineAnnotation: "线标注",
    polygonAnnotation: "面标注",
    measureDistance: "测量距离",
    measureArea: "测量面积",
    measureVolume: "测量体积",
    profileAnalysis: "剖面分析",
    modelClipping: "模型裁剪",
    swipeComparison: "滑动对比",
    shareView: "共享视图",
    exportReport: "导出报告",
    createBookmark: "创建书签",
    screenshot: "截图",
    settings: "设置",
    profileAnalysis: "剖面分析",
    plotting: "标绘",
    profile: "剖面",
    cModels: "剖切模型",
    sourceLayers: "源图层",
    profileTool: {
      defaultName: "剖面 {count}",
      startPoint: "起点",
      endPoint: "终点",
      operationPreview: "操作预览",
    },
    timeUnit: {
      year: "年",
      month: "月",
      day: "日",
      hour: "时",
    },
    untitledProject: "未命名项目",
    drawLineOnMapToGenerateProfile: "在地图上绘制线条以生成剖面",
    clippingTool: "裁剪工具",
    drawAPolygonToDefineClippingArea: "绘制多边形以定义裁剪区域",
    keepInside: "保留内部",
    keepOutside: "保留外部",
    clearClipping: "清除裁剪",
    shareThisView: "共享此视图",
    shareableLink: "可共享链接",
    setPasswordOptional: "设置密码（可选）",
    linkExpiresIn: "链接有效期",
    expirationDate: "过期日期",
    days: "天",
    generateQRCode: "生成二维码",
    recipientsCanViewButCannotEdit: "接收者可以查看当前场景，但无法编辑。",
    distance: "距离",
    area: "面积",
    volume: "体积",
    bookmarkSaved: "书签已保存",
    screenshotSaved: "截图已保存至下载文件夹",
    screenshotFailed: "截图失败",
    modeSwitch: {
      switchTo2D: "切换至 2D 模式",
      switchTo3D: "切换至 3D 模式",
      zoomIn: "放大",
      zoomOut: "缩小",
      resetView: "重置视图",
      roam: "漫游",
      pointTool: "点工具",
      lineTool: "线工具",
      polygonTool: "面工具",
      circleTool: "圆形工具",
      volumeTool: "体积工具",
      profileTool: "剖面工具",
      cutModelTool: "模型裁剪工具",
    },
    shareSettings: {
      title: "分享设置",
      shareLink: "分享链接",
      encryption: "加密",
      browserNotSupport: "您的浏览器不支持剪贴板功能",
      copySuccess: "链接复制成功",
      copyFailed: "链接复制失败",
      preview3D: "3D 预览功能，可基于 green-3d 扩展业务逻辑",
      generatingQRCode: "二维码生成中…",
      hours24: "24 小时",
      days7: "7 天",
      days14: "14 天",
      customize: "自定义",
      hour: "小时",
      day: "天",
      week: "周",
      month: "月",
      preview3D: "3D 预览",
      application: "应用",
      qrCode: "二维码",
      scanQRCode: "扫描二维码",
      copy: "复制链接",
      advanced: "高级选项",
      validityPeriod: "分享有效期",
      generatingQRCode: "二维码生成中…",
      scanQRCode: "扫描二维码",
    },
    // UI组件相关
    systemSettings: {
      title: "系统设置",
      backgroundColor: "背景颜色",
      spawnPointSettings: "初始位置设置",
      setSpawnPoint: "设置初始位置",
      skybox: "天空盒",
      light: "亮色",
      black: "黑色",
      white: "白色",
      iconAlt: "设置图标",
    },
    bottomToolbar: {
      share: "分享",
      export: "导出",
      compare: "对比",
      bookmark: "书签",
      exportConfig: "截图",
      importConfig: "导入配置",
      exportPdfSuccess: "报告导出成功",
      exportPdfFailed: "报告导出失败",
      exportPdfNoTask: "请先选择任务",
    },
    pointCloudCompare: {
      title: "多期对比",
      unavailableTitle: "无法使用多期对比",
      missingProjectId: "缺少工程 ID。",
      insufficientTasks: "当前工程任务数量不足两个。",
      syncCamera: "同步视角",
      close: "关闭",
      leftPeriod: "左侧期次",
      rightPeriod: "右侧期次",
    },
    bookmark: {
      title: "书签",
      name: "名称",
      namePlaceholder: "请输入书签名称",
      description: "描述",
      descriptionPlaceholder: "请输入描述",
      save: "保存",
      cancel: "取消",
      edit: "编辑",
      delete: "删除",
      loadFailed: "加载书签失败",
      saveSuccess: "书签保存成功",
      saveFailed: "书签保存失败",
      loading: "加载中…",
      noBookmarks: "暂无书签",
      only3DSaveWarning: "仅支持在 3D 场景下保存书签",
      viewNotReadyWarning: "当前视角尚未就绪，无法保存书签",
      only3DApplyWarning: "仅支持在 3D 场景下应用书签",
      appliedSuccess: "书签视角已应用",
      nameMinLength: "名称长度不得少于 2 个字符",
      nameMaxLength: "名称长度不得超过 20 个字符",
    },
    layerTree: {
      filterPlaceholder: "按名称和标签筛选…",
      layers: "图层",
      detail: "详情",
      delete: "删除",
      pointCloudLayers: "点云图层",
      trajectory: "轨迹",
      vectorLayers: "矢量图层",
      newPlotLayer: "新建标绘图层",
      deletePrompt: "确定要删除「{name}」吗？",
    },
    share: {
      title: "分享",
      shareLink: "分享链接",
      encryption: "加密",
      copy: "复制",
      preview3D: "3D 预览",
      advanced: "高级选项",
      validityPeriod: "分享有效期",
      hours24: "24 小时",
      days7: "7 天",
      days14: "14 天",
      customize: "自定义",
      hour: "小时",
      day: "天",
      week: "周",
      month: "月",
      application: "应用",
      qrCode: "二维码",
      scanQRCode: "扫描二维码",
      copySuccess: "链接复制成功",
      copyFailed: "链接复制失败",
      browserNotSupport: "您的浏览器不支持剪贴板功能",
      previewMessage: "3D 预览功能，可基于 green-3d 扩展业务逻辑",
      generatingQRCode: "二维码生成中…",
    },
    cutModel: {
      cropEffect: "裁剪效果",
      boxInfo: "裁切范围",
      highlight: "高亮",
      internal: "内部",
      external: "外部",
      position: "位置",
      scale: "尺寸",
      rotation: "旋转",
      long: "长",
      wide: "宽",
      tall: "高",
      x: "X",
      y: "Y",
      z: "Z",
      defaultName: "裁剪 {count}",
      maxLimitReached: "已达到最大裁剪数量（8 个），请先删除现有裁剪",
      boundsUnavailable: "点云范围不可用，请等待点云加载完成后再裁剪",
    },
    lineDetails: {
      lineWidth: "线宽",
      color: "颜色",
      opacity: "不透明度",
      length2d: "2D 长度",
      length3d: "3D 长度",
      minElevation: "最小高程",
      maxElevation: "最大高程",
      elevationDiff: "高程差",
      minSlope: "最小坡度",
      maxSlope: "最大坡度",
    },
    polygonDetails: {
      lineWidth: "线宽",
      color: "颜色",
      opacity: "不透明度",
      length2d: "2D 长度",
      length3d: "3D 长度",
      area2d: "2D 面积",
      area3d: "3D 面积",
      perimeter2d: "2D 周长",
      perimeter3d: "3D 周长",
      minElevation: "最小高程",
      maxElevation: "最大高程",
      borderColor: "边框颜色",
      fillColor: "填充颜色",
      elevationDiff: "高程差",
      slope: "坡度",
    },
    profileDetails: {
      thickness: "厚度",
      colorMode: "颜色模式",
      none: "无",
      customColor: "自定义颜色",
    },
    pointCloud: {
      metadata: "元数据",
      pointCount: "点数",
      boundingBox: "包围盒",
      renderSetting: "渲染设置",
      pointSize: "点大小",
      pointMode: "点模式",
      pointShape: "点形状",
      attribute: "属性",
      heightRange: "高度范围",
      colorRamp: "色带",
      edl: "EDL（Eye Dome Lighting）",
      rgb: "RGB",
      elevation: "高程",
      borderWidth: "边框宽度",
      borderColor: "边框颜色",
      Easting: "东距",
      intensity: "强度",
      classification: "分类",
      returnNumber: "回波号",
      pointSourceId: "点源 ID",
      circle: "圆形",
      square: "方形",
      paraboloid: "抛物面",
      rainbow: "彩虹",
      viridis: "Viridis",
      plasma: "Plasma",
      inferno: "Inferno",
      magma: "Magma",
      grayscale: "灰度",
      min: "最小",
      max: "最大",
      type: "类型",
      size: "大小",
      color: "颜色",
      attribute: "属性",
      Easting: "东距",
      Northing: "北距",
      opacity: "不透明度",
      imageTag: "图片标签",
      select: "选择",
      iconEmptyTip: "暂无图标，请点击上方上传按钮添加",
      iconDeleteSuccess: "图标删除成功",
      Z: "Z",
      coordinatesWgs84: "WGS84 坐标",
      numberOfReturns: "回波次数颜色",
    },
  },
};
